import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { TokenContext } from "./TokenContext";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import ModalComponent from "./ModalComponent";
import TipoAbitazioneEnum from "./TipoAbitazioneEnum";
import TipoAbitazioneBarriereEnum from "./TipoAbitazioneBarriereEnum";
import TipoAbitazioneLuogoEnum from "./TipoAbitazioneLuogoEnum";
import TipoCategoriaCatastale from "./TipoCategoriaCatastale.js";
import Repo from "../Utility/Repo";

function CondizioniAbitativeComponent({
  condizioniAbitative,
  cartellaSocialeId,
}) {
  const apiToken = useContext(TokenContext);
  const [showModalAdd, setshowModalAdd] = useState(false);
  const [showModalModify, setshowModalModify] = useState(false);
  const [selectedCategoriaId, setSelectedCategoriaId] = useState(null);

  const handleCategoriaChange = (selectedId) => {
    setSelectedCategoriaId(selectedId);
  };

  const [error, setError] = useState("");
  const initialFormData = {
    cartellaSocialeId: cartellaSocialeId,
    tipoAbitazione: 1,
    tipoAbitazioneLuogo: 1,
    tipoAbitazioneBarriere: 1,
    canoneAffitto: 0,
    spesaGiornaliera: 0,
    speseCondominiali: 0,
    metriQuadrati: 0,
  };
  const [formData, setFormData] = useState(initialFormData);

  const resetFormFields = () => {
    setFormData(initialFormData);
    setError("");
  };

  const toggleModalAdd = () => {
    resetFormFields();
    setshowModalAdd(!showModalAdd);
  };

  const toggleModalModify = () => {
    setshowModalModify(!showModalModify);
  };

  const handleCloseModalAdd = () => {
    setshowModalAdd(false);
    resetFormFields();
  };

  const handleCloseModalModify = () => {
    setshowModalModify(false);
    resetFormFields();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const showAdd = () => {
    resetFormFields();
    setshowModalAdd(true);
  };

  const handleDelete = (recordId) => {
    const confirmDelete = window.confirm(
      "Sei sicuro di voler eliminare questo record?"
    );

    if (confirmDelete) {
      // Chiamata API per eliminare il record
      Repo.DelCondizioneAbitative(apiToken, recordId)
        .then((response) => {
          if (response.status === 204) {
            // Aggiorna lo stato o effettua altre azioni dopo l'eliminazione
            // Ad esempio, puoi ricaricare i dati o aggiornare il componente.
            window.location.reload();
          }
        })
        .catch((error) => {
          setError(error.response?.data?.Message || error.response?.data || "");
        });
    }
  };

  const handleModify = (recordId, ogg) => {
    if (!selectedCategoriaId) {
      setError("Seleziona una categoria catastale");
      return;
    }
    setshowModalModify(true);
    formData.id = recordId;
    formData.cartellaSocialeId = cartellaSocialeId;
    formData.canoneAffitto = ogg.canoneAffitto;
    formData.spesaGiornaliera = ogg.spesaGiornaliera;
    formData.speseCondominiali = ogg.speseCondominiali;
    formData.tipoAbitazione = ogg.tipoAbitazione;
    formData.tipoAbitazioneLuogo = ogg.tipoAbitazioneLuogo;
    formData.tipoAbitazioneBarriere = ogg.tipoAbitazioneBarriere;

    // Nuovi campi aggiunti
    formData.metriQuadrati = ogg.metriQuadrati;
    formData.nominativo = ogg.nominativo;
    formData.codiceFiscale = ogg.codiceFiscale;
    formData.foglio = ogg.foglio;
    formData.particella = ogg.particella;
    formData.subalterno = ogg.subalterno;
    formData.via = ogg.via;
    formData.civico = ogg.civico;
    bodyModify();
  };

  const handleSave = () => {
    if (!selectedCategoriaId) {
      setError("Seleziona una categoria catastale.");
      return;
    }
    const {
      tipoAbitazione,
      tipoAbitazioneLuogo,
      tipoAbitazioneBarriere,
      canoneAffitto,
      spesaGiornaliera,
      speseCondominiali,
      categoriaId,
      metriQuadrati,
      nominativo,
      codiceFiscale,
      foglio,
      particella,
      subalterno,
      via,
      civico,
    } = formData;

    const data = {
      cartellaSocialeId,
      tipoAbitazione: parseInt(tipoAbitazione, 10),
      tipoAbitazioneLuogo: parseInt(tipoAbitazioneLuogo, 10),
      tipoAbitazioneBarriere: parseInt(tipoAbitazioneBarriere, 10),
      canoneAffitto,
      spesaGiornaliera,
      speseCondominiali,
      categoriaId: selectedCategoriaId,

      // Nuovi campi aggiunti
      metriQuadrati: parseFloat(metriQuadrati) || 0,
      nominativo,
      codiceFiscale,
      foglio,
      particella,
      subalterno,
      via,
      civico,
    };

    Repo.AddCondizioneAbitative(apiToken, JSON.stringify(data))
      .then((response) => {
        if (response.status === 200) {
          setshowModalAdd(false);
          window.location.reload();
        }
      })
      .catch((error) => {
        console.log(error);
      });

    resetFormFields();
  };

  const handleUpd = (id) => {
    const {
      tipoAbitazione,
      tipoAbitazioneLuogo,
      tipoAbitazioneBarriere,
      canoneAffitto,
      spesaGiornaliera,
      speseCondominiali,
      metriQuadrati,
      nominativo,
      codiceFiscale,
      foglio,
      particella,
      subalterno,
      via,
      civico,
    } = formData;

    const data = {
      id, // Assicurati che `id` sia presente in formData
      cartellaSocialeId,
      tipoAbitazione: parseInt(tipoAbitazione, 10),
      tipoAbitazioneLuogo: parseInt(tipoAbitazioneLuogo, 10),
      tipoAbitazioneBarriere: parseInt(tipoAbitazioneBarriere, 10),
      canoneAffitto,
      spesaGiornaliera,
      speseCondominiali,

      // Nuovi campi aggiunti
      metriQuadrati: parseFloat(metriQuadrati) || 0,
      nominativo,
      codiceFiscale,
      foglio,
      particella,
      subalterno,
      via,
      civico,
    };

    Repo.UpdCondizioneAbitative(apiToken, JSON.stringify(data))
      .then((response) => {
        if (response.status === 200) {
          setshowModalAdd(false);
          window.location.reload();
        }
      })
      .catch((error) => {
        setError(error.response?.data?.Message || error.response?.data || "");
      });

    resetFormFields();
  };

  const bodyAdd = () => {
    return (
      <>
        <div className="row mb-lg-3">
          Inserisci una nuova condizione abitativa per l'assistito
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div>
              <input
                type="hidden"
                id="cartellaSocialeId"
                name="cartellaSocialeId"
                value={cartellaSocialeId}
                onChange={handleChange}
              />
            </div>
            <div className="select-wrapper pb-5">
              <label className="active" htmlFor="tipoAbitazione">
                Tipo di Abitazione:
              </label>
              <select
                id="tipoAbitazione"
                name="tipoAbitazione"
                value={formData.tipoAbitazione}
                onChange={handleChange}
              >
                {Object.keys(TipoAbitazioneEnum)
                  .filter(
                    (key) => typeof TipoAbitazioneEnum[key] !== "function"
                  )
                  .map((key) => {
                    const value = TipoAbitazioneEnum[key];
                    return (
                      <option key={value} value={value}>
                        {TipoAbitazioneEnum.getLabel(value)}
                      </option>
                    );
                  })}
              </select>
            </div>

            <div className="select-wrapper pb-5">
              <label className="active" htmlFor="tipoAbitazioneLuogo">
                Abitazione luogo posizione:
              </label>
              <select
                id="tipoAbitazioneLuogo"
                name="tipoAbitazioneLuogo"
                value={formData.tipoAbitazioneLuogo}
                onChange={handleChange}
              >
                {Object.keys(TipoAbitazioneLuogoEnum)
                  .filter(
                    (key) => typeof TipoAbitazioneLuogoEnum[key] !== "function"
                  )
                  .map((key) => {
                    const value = TipoAbitazioneLuogoEnum[key];
                    return (
                      <option key={value} value={value}>
                        {TipoAbitazioneLuogoEnum.getLabel(value)}
                      </option>
                    );
                  })}
              </select>
            </div>
            <div className="select-wrapper pb-5">
              <label className="active" htmlFor="tipoAbitazioneBarriere">
                Barriere architettoniche:
              </label>
              <select
                id="tipoAbitazioneBarriere"
                name="tipoAbitazioneBarriere"
                value={formData.tipoAbitazioneBarriere}
                onChange={handleChange}
              >
                {Object.keys(TipoAbitazioneBarriereEnum)
                  .filter(
                    (key) =>
                      typeof TipoAbitazioneBarriereEnum[key] !== "function"
                  )
                  .map((key) => {
                    const value = TipoAbitazioneBarriereEnum[key];
                    return (
                      <option key={value} value={value}>
                        {TipoAbitazioneBarriereEnum.getLabel(value)}
                      </option>
                    );
                  })}
              </select>
            </div>
            <div className="form-group">
              <label className="active" htmlFor="canoneAffitto">
                Canone di Affitto:
              </label>
              <input
                type="number"
                id="canoneAffitto"
                name="canoneAffitto"
                value={formData.canoneAffitto}
                onChange={handleChange}
              />
            </div>
            <div>
              <label htmlFor="spesaGiornaliera">Spesa Giornaliera:</label>
              <input
                type="number"
                id="spesaGiornaliera"
                name="spesaGiornaliera"
                value={formData.spesaGiornaliera}
                onChange={handleChange}
              />
            </div>
            <div>
              <label htmlFor="speseCondominiali">Spese Condominiali:</label>
              <input
                type="number"
                id="speseCondominiali"
                name="speseCondominiali"
                value={formData.speseCondominiali}
                onChange={handleChange}
              />
            </div>

            {/* Aggiungi gli altri campi nuovi */}

            <div className="select-wrapper pb-3 mt-4">
              <TipoCategoriaCatastale
                token={apiToken}
                onChangeCategoria={handleCategoriaChange} // Passa la callback
              />
            </div>
            <div>
              <label htmlFor="metriQuadrati">Superficie (mq):</label>
              <input
                type="number"
                id="metriQuadrati"
                name="metriQuadrati"
                value={formData.metriQuadrati}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="nominativo">Nominativo:</label>
              <input
                type="text"
                id="nominativo"
                name="nominativo"
                value={formData.nominativo}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="codiceFiscale">Codice Fiscale/Piva:</label>
              <input
                type="text"
                id="codiceFiscale"
                name="codiceFiscale"
                value={formData.codiceFiscale}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="foglio">Foglio:</label>
              <input
                type="text"
                id="foglio"
                name="foglio"
                value={formData.foglio}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="particella">Particella:</label>
              <input
                type="text"
                id="particella"
                name="particella"
                value={formData.particella}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="subalterno">Subalterno:</label>
              <input
                type="text"
                id="subalterno"
                name="subalterno"
                value={formData.subalterno}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="via">Via:</label>
              <input
                type="text"
                id="via"
                name="via"
                value={formData.via}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="civico">Civico:</label>
              <input
                type="text"
                id="civico"
                name="civico"
                value={formData.civico}
                onChange={handleChange}
              />
            </div>

            {error && (
              <div className="alert alert-danger row mt-2" role="alert">
                <b className="mr-2">Attenzione:</b> {error}.
              </div>
            )}
            <div className="d-flex justify-content-end">
              <button
                className="btn btn-primary btn-salva"
                type="button"
                onClick={() => handleSave()}
              >
                Salva
              </button>
            </div>
          </div>
        </div>
      </>
    );
  };

  const bodyModify = () => {
    return (
      <>
        <div className="row mb-lg-3">
          Modifica condizione abitativa per cartellaSocialeId{" "}
          {cartellaSocialeId}
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div>
              <input
                type="hidden"
                id="cartellaSocialeId"
                name="cartellaSocialeId"
                value={cartellaSocialeId}
                onChange={handleChange}
              />
            </div>
            <div className="select-wrapper pb-5">
              <label htmlFor="tipoAbitazione">Tipo di Abitazione:</label>
              <select
                id="tipoAbitazione"
                name="tipoAbitazione"
                value={formData.tipoAbitazione}
                onChange={handleChange}
              >
                {Object.keys(TipoAbitazioneEnum)
                  .filter(
                    (key) => typeof TipoAbitazioneEnum[key] !== "function"
                  )
                  .map((key) => {
                    const value = TipoAbitazioneEnum[key];
                    return (
                      <option key={value} value={value}>
                        {TipoAbitazioneEnum.getLabel(value)}
                      </option>
                    );
                  })}
              </select>
            </div>

            <div className="select-wrapper pb-5">
              <label className="active" htmlFor="tipoAbitazioneLuogo">
                Abitazione luogo posizione:
              </label>
              <select
                id="tipoAbitazioneLuogo"
                name="tipoAbitazioneLuogo"
                value={formData.tipoAbitazioneLuogo}
                onChange={handleChange}
              >
                {Object.keys(TipoAbitazioneLuogoEnum)
                  .filter(
                    (key) => typeof TipoAbitazioneLuogoEnum[key] !== "function"
                  )
                  .map((key) => {
                    const value = TipoAbitazioneLuogoEnum[key];
                    return (
                      <option key={value} value={value}>
                        {TipoAbitazioneLuogoEnum.getLabel(value)}
                      </option>
                    );
                  })}
              </select>
            </div>
            <div className="select-wrapper pb-5">
              <label className="active" htmlFor="tipoAbitazioneBarriere">
                Barriere architettoniche:
              </label>
              <select
                id="tipoAbitazioneBarriere"
                name="tipoAbitazioneBarriere"
                value={formData.tipoAbitazioneBarriere}
                onChange={handleChange}
              >
                {Object.keys(TipoAbitazioneBarriereEnum)
                  .filter(
                    (key) =>
                      typeof TipoAbitazioneBarriereEnum[key] !== "function"
                  )
                  .map((key) => {
                    const value = TipoAbitazioneBarriereEnum[key];
                    return (
                      <option key={value} value={value}>
                        {TipoAbitazioneBarriereEnum.getLabel(value)}
                      </option>
                    );
                  })}
              </select>

              <div>
                <label htmlFor="canoneAffitto">Canone di Affitto:</label>
                <input
                  type="number"
                  id="canoneAffitto"
                  name="canoneAffitto"
                  value={formData.canoneAffitto}
                  onChange={handleChange}
                />
              </div>
              <div>
                <label htmlFor="spesaGiornaliera">Spesa Giornaliera:</label>
                <input
                  type="number"
                  id="spesaGiornaliera"
                  name="spesaGiornaliera"
                  value={formData.spesaGiornaliera}
                  onChange={handleChange}
                />
              </div>
              <div>
                <label htmlFor="speseCondominiali">Spese Condominiali:</label>
                <input
                  type="number"
                  id="speseCondominiali"
                  name="speseCondominiali"
                  value={formData.speseCondominiali}
                  onChange={handleChange}
                />
              </div>

              {/* Altri campi aggiunti */}
              <div className="select-wrapper pb-3 mt-4">
                <TipoCategoriaCatastale
                  token={apiToken}
                  onChangeCategoria={handleCategoriaChange} // Passa la callback
                />
              </div>
            </div>
            <div>
              <label htmlFor="metriQuadrati">Superficie (mq):</label>
              <input
                type="number"
                id="metriQuadrati"
                name="metriQuadrati"
                value={formData.metriQuadrati}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="nominativo">Nominativo:</label>
              <input
                type="text"
                id="nominativo"
                name="nominativo"
                value={formData.nominativo}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="codiceFiscale">Codice Fiscale/Piva:</label>
              <input
                type="text"
                id="codiceFiscale"
                name="codiceFiscale"
                value={formData.codiceFiscale}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="foglio">Foglio:</label>
              <input
                type="text"
                id="foglio"
                name="foglio"
                value={formData.foglio}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="particella">Particella:</label>
              <input
                type="text"
                id="particella"
                name="particella"
                value={formData.particella}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="subalterno">Subalterno:</label>
              <input
                type="text"
                id="subalterno"
                name="subalterno"
                value={formData.subalterno}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="via">Via:</label>
              <input
                type="text"
                id="via"
                name="via"
                value={formData.via}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="civico">Civico:</label>
              <input
                type="text"
                id="civico"
                name="civico"
                value={formData.civico}
                onChange={handleChange}
              />
            </div>

            {error && (
              <div className="alert alert-danger mt-2" role="alert">
                <b className="mr-2">Attenzione:</b> {error}.
              </div>
            )}
            <div className="d-flex justify-content-end">
              <button
                className="btn btn-primary btn-salva"
                type="button"
                onClick={() => handleUpd(formData.id)}
              >
                Modifica
              </button>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="col-lg-12">
      <div className="card-wrapper card-space">
        <div className="card card-bg no-after card-big roundedCustom">
          <div className="etichetta">
            <svg className="icon icon-primary">
              <use href={`${iconSprite}#it-plus`}></use>
            </svg>
            <span>
              {" "}
              <a
                className="text-decoration-none"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  showAdd();
                }}
              >
                Aggiungi
              </a>
            </span>
          </div>
          <div className="card-body" key="condizioniAbitative">
            <div className="row">
              <div className="col-lg-9">
                <h5>Dettagli Condizioni Abitative</h5>
              </div>
            </div>

            {condizioniAbitative && condizioniAbitative.length > 0 ? (
              condizioniAbitative.map((x) => (
                <div key={x.id}>
                  <div className="row mt-4">
                    <div className="col-lg-11 text-left">
                      Data: <strong>{x.dataCreazione}</strong>
                    </div>
                    <div className="col-lg-1 d-flex justify-content-end">
                      <button
                        className="btn btn-outline-primary p-1"
                        type="button"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Modifica"
                        onClick={() => handleModify(x.id, x)}
                      >
                        <svg className="icon icon-primary">
                          <use href={`${iconSprite}#it-pencil`} />
                        </svg>
                      </button>

                      <button
                        className="btn btn-outline-danger p-1 ml-1"
                        type="button"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Elimina"
                        onClick={() => handleDelete(x.id)}
                      >
                        <svg className="icon icon-danger">
                          <use href={`${iconSprite}#it-delete`} />
                        </svg>
                      </button>
                    </div>
                  </div>
                  <div className="row mt-4">
                    <div className="col-lg-4 text-left">
                      Spese:
                      <br />
                      Canone affitto o mutuo{" "}
                      <strong> {x.canoneAffitto} €</strong> <br />
                      Condominio <strong>{x.speseCondominiali} €</strong> <br />
                      Costo gornaliero ricovero{" "}
                      <strong>{x.spesaGiornaliera} €</strong>
                    </div>

                    <div className="col-lg-2 text-left">
                      Tipo abitazione: <br />
                      <strong>
                        {" "}
                        {TipoAbitazioneEnum.getLabel(x.tipoAbitazione)}
                      </strong>
                    </div>

                    <div className="col-lg-3 text-left">
                      Posizionamento abitazione: <br />
                      <strong>
                        {" "}
                        {TipoAbitazioneLuogoEnum.getLabel(
                          x.tipoAbitazioneLuogo
                        )}
                      </strong>
                    </div>
                    <div className="col-lg-3 text-left">
                      Barriere architettoniche: <br />
                      <strong>
                        {" "}
                        {TipoAbitazioneBarriereEnum.getLabel(
                          x.tipoAbitazioneBarriere
                        )}
                      </strong>
                    </div>
                  </div>
                  <hr />
                  {/* Aggiungi qui i nuovi campi */}
                  <h5>Dettagli immobile</h5>
                  <div className="row mt-4">
                    <div className="col-lg-4 text-left">
                      Nominativo: <strong>{x.nominativo}</strong>
                    </div>
                    <div className="col-lg-4 text-left">
                      Codice Fiscale/Piva: <strong>{x.codiceFiscale}</strong>
                    </div>
                    <div className="col-lg-4 text-left">
                      Superficie (mq): <strong>{x.metriQuadrati}</strong>
                    </div>
                  </div>

                  <div className="row mt-4">
                    <div className="col-lg-4 text-left">
                      Indirizzo:{" "}
                      <strong>
                        {x.via} {x.civico}
                      </strong>
                    </div>
                    <div className="col-lg-8 text-left">
                      Catasto: Foglio: <strong>{x.foglio}</strong> Part:{" "}
                      <strong>{x.particella}</strong> Sub:{" "}
                      <strong>{x.subalterno}</strong>
                    </div>
                  </div>
                  <hr />
                </div>
              ))
            ) : (
              <> Non ci sono condizioni abitative disponibili.</>
            )}
          </div>
        </div>
      </div>

      <ModalComponent
        toggleModal={toggleModalAdd}
        isOpen={showModalAdd}
        header="Aggiungi"
        body={bodyAdd()}
        buttonDeny="Chiudi"
        onClose={handleCloseModalAdd}
      />

      <ModalComponent
        toggleModal={toggleModalModify}
        isOpen={showModalModify}
        header="Modifica"
        body={bodyModify()}
        buttonDeny="Chiudi"
        onClose={handleCloseModalModify}
      />
    </div>
  );
}

export default CondizioniAbitativeComponent;
